var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_3d = require("editor-3d-light");
var cio_datamodel = require("cio-datamodel");
var THREE           = require("three");
var ui_extensions = require("ui-extensions");
var FootprintInstanceInteractionModel = require("./footprintInstanceInteractionModel");
var FootprintInstanceInteractionView = require("./footprintInstanceInteractionView.js");
var cio_config = require("cio-config");


/////////////////////
var PackageFootprintViewerModel = function(data, switcherModel, editorModel, boardModel, selectionModel, cameraModel, processModel, errorModel, masterModel, userSettingsModel, editorView, config){
    var self = this;
    lib_core.Model.call(this);

    this.data = data;
    this.switcherModel = switcherModel;
    this.editorModel = editorModel;
    this.boardModel = boardModel;
    this.editorView = editorView;
    this.selectionModel = selectionModel;
    this.cameraModel = cameraModel;
    this.config = config;
    this.footprintOpen = config.footprintOpen;
    this.versionEdit = config.versionEdit;
    this.placementEdit = config.placementEdit;
    this.processModel = processModel;
    this.errorModel = errorModel;
    this.masterModel = masterModel;
    this.userSettingsModel = userSettingsModel;
    this.cameraMoved = false;

    this.masterModel.wizardMode.onChange(this, function(){
        self.resetCamera();
    });

    this.inspectorSubjects = this.set("inspectorSubjects", false);
    //this.versionSubject = this.set("versionSubjects", true);

/////////////// The footprint IM
    this.currentFootprintModel = this.value("currentFootprintModel", false);

    // And interaction data for the 3d props //////////////////////////////////////////////////////
    this.packageThreejsRenderGroup = this.value("packageThreejsRenderGroup", true)
    this.packageGeometry = this.value("packageGeometry", true);

    this.showBoard = this.value("showBoard", true);
    this.showFootprint = this.value("showFootprint", true);
    this.show3dModel = this.value("show3dModel", true);
    this.showGrid = this.value("showGrid", true);
    this.packageTransparency = this.value("modelTransparency", true);
    this.showCustomSolderPaste = this.value("showCustomSolderPaste", true);
    this.showCustomSolderPaste(true); //always show custom solder paste for pads

    this.packageTransparency.onChange("valueLimit", function(val){
        if(val > 100){
            self.packageTransparency(100);
        }
    })

     // whether the package is rotated and centered by its centroid or not
     this.modelCenterOrigin = this.value("modelCenterOrigin", true);
     this.modelCenterOrigin(false);

     this.footprintCenterOrigin = this.value("footprintCenterOrigin", true);
     this.footprintCenterOrigin(false);

    // derivatives of the above
    this.boundingGeometry = this.shadow("boundingGeometry", function(){
            if(!this.packageGeometry()) return null;
            return this.packageGeometry().getIntersectMesh(60000);
        },
        null,
        [this.packageGeometry]
    );

    this.radius = this.shadow("radius", function(){
            if(!this.packageGeometry()) return null;
            return this.packageGeometry().getRadius();
        },
        null,
        [this.packageGeometry]
    );

    this.centroid = this.shadow("centroid", function(){
            if(!this.packageGeometry()) return null;
            return this.packageGeometry().getCentroid();
        },
        null,
        [this.packageGeometry]
    );

    this.sizeX = this.shadow("sizeX",
        function(){
            if(!self.packageGeometry()) return 0;
            return cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, this.userSettingsModel.distanceUnit(), self.packageGeometry().getSize().getX() );
        },
        function(val){
            if(self.data.model3d() instanceof cio_datamodel.BoxData){
                self.data.model3d().sizeX( cio_config.UnitConversions.convert( this.userSettingsModel.distanceUnit(), cio_config.UnitConversions.distanceDataUnit, val));
                return true;
            }
            return false;
        },
        [self.packageGeometry, this.userSettingsModel.distanceUnit]
    );

    this.sizeY = this.shadow("sizeY",
        function(){
            if(!self.packageGeometry()) return 0;
            return cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, this.userSettingsModel.distanceUnit(), self.packageGeometry().getSize().getY() );  
        },
        function(val){
            if(self.data.model3d() instanceof cio_datamodel.BoxData){
                self.data.model3d().sizeY(cio_config.UnitConversions.convert( this.userSettingsModel.distanceUnit(), cio_config.UnitConversions.distanceDataUnit, val));
                return true;
            }
            return false;
        },
        [self.packageGeometry, this.userSettingsModel.distanceUnit]
    );

    this.sizeZ = this.shadow("sizeZ",
        function(){
            if(!self.packageGeometry()) return 0;
            return cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, this.userSettingsModel.distanceUnit(), self.packageGeometry().getSize().getZ() );
        },
        function(val){
            if(self.data.model3d() instanceof cio_datamodel.BoxData){
                self.data.model3d().sizeZ(cio_config.UnitConversions.convert( this.userSettingsModel.distanceUnit(), cio_config.UnitConversions.distanceDataUnit, val));
                return true;
            }
            return false;
        },
        [self.packageGeometry, this.userSettingsModel.distanceUnit]
    );

    /////////////////// dependancy listeners ////////////////////////
    // when camera state goes to idol, select the current footprint (keep selection)
    this.cameraModel.state.onChange({}, function(val){
        if(val == "none" && self.currentFootprintModel() && config.autoSelect){
            self.selectionModel.select(self.currentFootprintModel());
        } else if(val != "none" && self.currentFootprintModel()){
            self.currentFootprintModel().snapped(false);
        }
    }, 100);

    // when the switcher changes, remove old footprint IM and create new
    switcherModel.selectedItem.onChange({}, function(val, old){

        if(val){
            self.createFootprintInteractionModel(val.data);
        } else {
            if(self.currentFootprintModel()) {
                self.currentFootprintModel().remove();
                self.currentFootprintModel(null);
            }
        }

        if(config.resetCameraWithSwitcher) self.resetCamera();

        if(self.currentFootprintModel()) {
            self.currentFootprintModel().snapped(false);
            self.selectionModel.select(self.currentFootprintModel())
        }

        if(!self.cameraMoved){
            self.resetCamera();
            self.cameraMoved = true;
        }
    });


    /////////////////////////////////////////

    ///////// when the model changes we need to rebuild  the geometry.
    this.data.model3d.onBubble("rebuildGeometry", function(treeEv){
        //reset settings
        self.modelCenterOrigin(false);

        // deselect the current footprint
        self.selectionModel.deselectAll();
        if(self.currentFootprintModel()){
            // if here, changing the package over a footprint
            self.currentFootprintModel().snapped(false);
            self.selectionModel.select(self.currentFootprintModel());

        }

        if(self.data.model3d()) {
            self.loadPackage();
        } else {
            self.packageGeometry(null);
            self.packageThreejsRenderGroup(null);
        }
    }, 10);

    this.data.model3d.onChange("reposition", function(newval, oldval){
        if(newval) {
            // deselect the current footprint
            if(newval instanceof cio_datamodel.Model3DReference){
                self.packageTransparency(100);
                self.resetModel3dTransformationInFootprintInstances();
            } else {
                self.packageTransparency(90);
            }
        } else {
            self.resetModel3dTransformationInFootprintInstances();
        }
        
    }, 10);

    // if 'modelUploadedManually' goes to false that means a preview has been generated
    self.data.is3dModelUploadedManually.onChange("opacityChange", function(newval, oldval){
        if(!newval){
            self.packageTransparency(100);
        }
    });

    if(self.data.model3d()) self.loadPackage();

    if(switcherModel.selectedItem()){
        self.createFootprintInteractionModel(switcherModel.selectedItem().data);
        self.resetCamera();
    }
    
    // popup controllers for fusion error situations
    this.emptyObjModalShown = this.value("emptyObjModalShown", true);
    this.emptyObjLinkedModalShown = this.value("emptyObjLinkedModalShown", true);
    this.xrefObjModalShown = this.value("xrefObjModalShown", true);
    this.fusionLinkedModalShown = this.value("fusionLinkedModalShown", true);
    
};

lib_core.inherit(PackageFootprintViewerModel, lib_core.Model);
PackageFootprintViewerModel.$class = "PackageFootprintViewerModel";
module.exports = PackageFootprintViewerModel;


PackageFootprintViewerModel.prototype.loadPackage = function(){
    var self = this;
    self.processModel.addLoad("PackageGeometry", "Loading 3D model...");
    this.data.calculateGeometryInfo()
    .then( info => {
        // after geometry is calculated we will know if its a special case
        if(self.data.model3d().isFusionLinked && self.data.model3d().emptyFromNoGeom){
          self.emptyObjLinkedModalShown(true);
        }
        else if (self.data.model3d().emptyFromNoGeom){
          self.emptyObjModalShown(true);
        }
        else if(self.data.model3d().emptyFromXref){
          self.xrefObjModalShown(true);
        } else if(self.data.model3d().isFusionLinked){
          self.fusionLinkedModalShown(true);
        }
        
        if(self.editorView.usingCanvas){
            self.editorView.makeWifreframe(info[0]);
        }
        self.packageGeometry(info[1]);
        self.packageThreejsRenderGroup(info[0]);
        self.processModel.removeLoad("PackageGeometry");
        self.selectionModel.select(self.currentFootprintModel());
    })
    .catch(function(reason){
        self.processModel.removeLoad("PackageGeometry");
        var error = new Error("Failed to build package geometry.");
        logError("Package Viewer Model", error, logError.criticality.MAJOR, reason);
        throw error;
    });
}

PackageFootprintViewerModel.prototype.createFootprintInteractionModel = function(footprintData){
    var self = this;

    if(this.currentFootprintModel()){
        this.editorModel.interactionModelDataMap.remove(this.currentFootprintModel().data);
    }

    var im = new FootprintInstanceInteractionModel( footprintData, this, this.config);

    this.currentFootprintModel(im);
    this.editorModel.interactionModelDataMap.put(this.currentFootprintModel().data, im);

    this.inspectorSubjects.add(im);

    var view = new FootprintInstanceInteractionView(this.editorView, im, this.cameraModel, this.packageThreejsRenderGroup, this.config);

    im.onDie({}, function(){
        self.selectionModel.deselectAll();
        view.erase();
    }, 0);
}

PackageFootprintViewerModel.prototype.buildDefaultBoxForCurrentFootprint = function(){
    if( this.switcherModel.selectedItem() ) {
        var fdata = this.switcherModel.selectedItem().data;
        var bb = fdata.padsBoundingBox();
        if(!bb){
            bb = fdata.boundingBox();
        }
        if(!bb){
            this.data.model3d(new cio_datamodel.BoxData(4000, 4000, 1000));
            return;
        }
        // default to 1 mm height
        var height = 1000;

        this.data.model3d(new cio_datamodel.BoxData(
            bb.width,
            bb.height,
            height
        ) );

        this.data.footprintInstances.forEach(function(ind, footprintData){
            var boundingBox = footprintData.padsBoundingBox();
            if(!boundingBox){
                boundingBox = footprintData.boundingBox();
            }
            if(!boundingBox){
                return;
            }

            var pos = new lib_geometry.Coord3d(
                boundingBox.x + boundingBox.width/2,
                boundingBox.y + boundingBox.height/2,
                0 );

            footprintData.model3dPosition(pos);
            footprintData.model3dRotation(new lib_geometry.Coord3d(0,0,0));
        })

    } else {
        this.data.model3d(new cio_datamodel.BoxData(4000, 4000, 1000));
    }
}

PackageFootprintViewerModel.prototype.placeDown = function(){
    if(this.currentFootprintModel())
        this.currentFootprintModel().resetZtoBoard();
}

PackageFootprintViewerModel.prototype.center = function(){
    if(this.currentFootprintModel())
        this.currentFootprintModel().centerModel();
}

PackageFootprintViewerModel.prototype.centerAll = function(){
    this.currentFootprintModel().centerModel();
}

PackageFootprintViewerModel.prototype.exportFootprint = function(){
    this.currentFootprintModel().exportFootprint();
}

PackageFootprintViewerModel.prototype.resetCamera = function(){
    if(!this.currentFootprintModel()) return;

    // TODO this should be done in the camera, not this terrible hack below :P

    var bb = this.currentFootprintModel().boundingBox();
    var center2d = new lib_geometry.Coord(
        bb.x + bb.width/2, bb.y + bb.height/2
    );
    var scale = cio_config.UnitConversions.convert(cio_config.UnitConversions.distanceDataUnit, cio_config.UnitConversions.defaultDisplayUnit, 1)
    center2d = center2d.mult( scale);
    var center3d = new lib_geometry.Coord3d(center2d.x, center2d.y, 0);

    // TODO this is a rediculous hack
    var boardwidth = bb.width * scale;
    var cameraPos = new lib_geometry.Coord3d(center3d.x, center3d.y - boardwidth, center3d.z + boardwidth);
    this.cameraModel.cameraTarget(center3d);
    this.cameraModel.perspectiveCameraPosition(cameraPos);
    this.cameraModel.orthoCameraPosition(cameraPos);
    this.cameraModel.orthoZoom(Math.pow(boardwidth, -1) * 50);
}

PackageFootprintViewerModel.prototype.getInspectorSubjects = function(){
      var self = this;
      //return this.versionSubject;
      return this.set("null", true);
}

PackageFootprintViewerModel.prototype.resetModel3dTransformationInFootprintInstances = function() {
    this.data.footprintInstances.forEach(function(ind, footprintData){
        footprintData.model3dPosition(new lib_geometry.Coord3d(0,0,0));
        footprintData.model3dRotation(new lib_geometry.Coord3d(0,0,0));
    });
}
